import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import REVIEW_TYPES from '../../../../../../constants/review-types';
import {DateHelpers} from '../../../../../../helpers/date-helpers';
import LinkBuilder from '../../../../../../helpers/link-builder';

const TypeFirmReview = props => {
  const {
    post: {
      FirmName,
      FirmUrlAlias,
      FirmActive,
      NewsFeedDateAdd,
      Date,
      TitleName,
      PublicName,
      AllowView,
      FirmTypeName,
      ReviewType,
    },
    actions: { handleClickReviewLink },
  } = props;

  const handleLinkClick = e => {
    handleClickReviewLink(e, {
      AllowView,
      TypeName: FirmTypeName,
      ReviewType,
    });
  };

  const firmLink =
    FirmActive === 'Yes' ? (
      <NavLink
        className="feed-post-content__hero"
        to={LinkBuilder.getFirmLink(FirmUrlAlias)}
      >
        {FirmName}
      </NavLink>
    ) : (
      <span className="feed-post-content__hero--span">{FirmName}</span>
    );

  const reviewLink = useMemo(() => {
    let link = '#';
    if (AllowView === 'Yes') {
      if (ReviewType === REVIEW_TYPES.EMPLOYEE) {
        link = LinkBuilder.getEmployeeLink(FirmUrlAlias, PublicName);
      } else if (ReviewType === REVIEW_TYPES.INTERVIEW) {
        link = LinkBuilder.getInterviewLink(FirmUrlAlias, PublicName);
      } else if (ReviewType === REVIEW_TYPES.OVERVIEW) {
        link = LinkBuilder.getOverviewLink(FirmUrlAlias, PublicName);
      }
    }
    return link;
  }, []);

  const date = useMemo(() => {
    const [year] = DateHelpers.getDateArray(Date);
    const currentYear = DateHelpers.getCurrentYear();

    return currentYear > Number(year)
      ? DateHelpers.getMonthNameDayYearFormat(Date)
      : NewsFeedDateAdd;
  }, [Date, NewsFeedDateAdd]);

  return (
    <div className="feed-post-content__inner feed-post-content__inner--typed">
      <div className="feed-post-content__top">
        {firmLink}
        <div className="feed-post-content__text">received</div>
        <NavLink
          className="feed-post-content__postition"
          to={reviewLink}
          onClick={handleLinkClick}
        >
          {TitleName}
        </NavLink>
        <div className="feed-post-content__text">review</div>
      </div>
      <div className="feed-post-content__date">{date}</div>
    </div>
  );
};

export default TypeFirmReview;
